<div class="min-h-[calc(100vh-4rem)] overflow-auto">
  <div class="flex justify-center items-center mt-36">
    <img
      src="assets/images/brand/Aedbis.brand_256.ico"
      alt="aedbis logo"
      class="mx-auto drop-shadow-[0_8px_12px_rgba(0,0,0,0.35)] h-20"
    />
  </div>

  @if (isLoggedIn) {
    <div class="max-w-md mx-auto mt-10 relative">
      <label for="default-search" class="mb-2 text-sm font-medium text-gray-900 sr-only white:text-white">Search</label>
      <div class="relative mb-1">
        <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
          <svg
            class="w-4 h-4 text-gray-500 dark:text-gray-400"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 20 20"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
            />
          </svg>
        </div>
        <input
          type="search"
          id="default-search"
          class="block w-full p-4 ps-10 text-sm text-gray-900 border border-gray-200 rounded-lg bg-gray-50 focus:ring-amazone-orange focus:border-amazone-orange"
          placeholder="000.00.000.000"
          [showMaskTyped]="true"
          mask="000.00.000.000"
          [(ngModel)]="searchTerm"
          (keyup)="onKeyUp($event)"
        />
        <button
          type="submit"
          class="text-white absolute end-2.5 bottom-2.5 bg-amazone-gray hover:bg-gray-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2"
          (click)="search()"
          appAgentAction
          agent="index-search-dtc"
          businessObject="dtc"
        >
          Search for DTC
        </button>
        <app-search-result-list
          class="absolute w-full top-14"
          [searchResults]="searchResults"
          [invalidSearchTerm]="invalidSearchTerm"
        ></app-search-result-list>
      </div>
      <div class="absolute -right-8 bottom-2.5">
        <app-help-popover [paragraphs]="paragraphs"></app-help-popover>
      </div>
    </div>
  } @else {
    <div class="flex justify-center items-center mt-10 mx-auto">
      <h1 class="text-2xl font-bold text-gray-600">Welcome to AEDBIS, please log in to access the system.</h1>
    </div>
  }
  <div class="flex absolute bottom-2 right-2 z-10">
    <app-contact-info></app-contact-info>
  </div>
  <div class="flex ms-2 bottom-2 left-2 absolute mt-30">
    <span
      class="bg-amber-100 text-amazone-orange text-xs font-medium me-2 px-2.5 py-0.5 rounded-sm border border-amazone-orange-light"
    >
      Client: {{ versionInfo }}<br />API: {{ backendVersionInfo }}<br />Environment: {{ backendEnvironment }}</span
    >
    <span class="inline-flex items-center justify-center">
      <a href="{{ openApiUri }}" class="flex items-center" target="_blank">
        <img
          src="assets/images/OpenAPI_specification.png"
          class="mr-3 h-6 sm:h-9 filter"
          alt="OpenAPI Specification"
        /> </a
    ></span>
  </div>
</div>
